import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
// import { Provider } from 'react-redux'
// import { configureStore } from './store'
// import { persistStore } from 'redux-persist'
// import { PersistGate } from 'redux-persist/lib/integration/react'
import App from './App';
import './index.css'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)
const basename = process.env.PUBLIC_URL || '/basename-not-working'

// const store = configureStore()
// const persistor = persistStore(store)

console.log('rendering index')


root.render(
    <React.StrictMode>
        {/* <Provider store={store}> */}
            {/* <PersistGate persistor={persistor} loading={<div>Loading...</div>}> */}
                <BrowserRouter
                basename={basename}
                >
                    <App />
                </BrowserRouter>
            {/* </PersistGate> */}
        {/* </Provider> */}
    </React.StrictMode>
)